export default "__VITE_ASSET__DnkH8Pai__"